import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export default function InfoSectionTable({
    cabecalho,
    data,
    titulo = "",
    tarjaTitulo = true,
    alturaMax = 200,
    headerFixo = false
}: InfoSectionTableProps) {

    const tableProps = tarjaTitulo ? {
        p: 1.5,
        px: 2,
        border: "1px solid #ccc",
        borderRadius: "0 0 4px 4px"
    } : {}

    return (
        <Box>
            {
                tarjaTitulo &&
                <Box p={1} bgcolor="#1b5e20" width="100%" borderRadius="4px 4px 0 0">
                    <Typography color="white" fontWeight="bold" variant="subtitle2">{titulo}</Typography>
                </Box>
            }

            <Box {...tableProps}>
                <TableContainer sx={{ maxHeight: alturaMax, overflow: "auto" }}>
                    <Table stickyHeader={headerFixo}>
                        <TableHead>
                            <TableRow>
                                {
                                    cabecalho.map((item, index) => (
                                        <TableCell key={index} align={item.align ?? "left"}><b>{item.label}</b></TableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                data.map((row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        {cabecalho.map((header, headerIndex) => (
                                            <TableCell align={header.align ?? "left"} key={headerIndex}>{row[header.prop]}</TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    )
}

interface InfoSectionTableProps {
    titulo?: string,
    cabecalho: Array<{
        label: string,
        prop: string,
        align?: "left" | "right" | "center",
    }>
    data: Array<any>,
    tarjaTitulo?: boolean,
    alturaMax?: number,
    headerFixo?: boolean
}